import React from 'react';
import Styled from 'styled';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SVGPureIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';
import ActionButtonView from 'four-nets/ui/action-button/action-button-view';
import notification from 'four-nets/icons/svg/icon_notifications.svg';
import { Category } from 'four-nets/forum/forum';
import { Context as ViewerContext } from 'four-nets/user/viewer/viewer';

import defaultStyles from './category-notification-button.scss';
import { observer } from 'mobx-react';

interface Props {
    styles: typeof defaultStyles;
    category: Category;
    viewer: ViewerContext['viewer'];
}

class CategoryNotificationButton extends React.Component<Props> {
    static contextTypes = {
        authCheck: PropTypes.func,
    };

    componentDidUpdate(prevProps: Props) {
        const { viewer: prevViewer } = prevProps;
        const { viewer, category } = this.props;

        if (!prevViewer && viewer) {
            category.getCategorySubscription();
        }
    }

    componentDidMount() {
        const { viewer, category } = this.props;
        if (viewer) {
            category.getCategorySubscription();
        }
    }

    render() {
        const { styles, category } = this.props;

        const toggleNotifications = () => {
            return this.context.authCheck(category.toggleNotifications, AuthOrigin.Notifications);
        };

        return (
            <span>
                <ActionButtonView
                    onClick={toggleNotifications}
                    icon={<SVGPureIcon src={notification} className={styles.notificationIcon} />}
                >
                    {category?.subscribed ? (
                        <FormattedMessage id='DISABLE_NOTIFICATIONS' />
                    ) : (
                        <FormattedMessage id='ENABLE_NOTIFICATIONS' />
                    )}
                </ActionButtonView>
            </span>
        );
    }
}

export default Styled(defaultStyles)(observer(CategoryNotificationButton));
